import { ArrowUpRight } from "lucide-react";
import { SectionHeading } from "../components/SectionHeading";
import { Reveal } from "../components/Reveal";
import { scrollToHash } from "../components/Navbar";
import { CATEGORIES } from "../data/content";

export const Products = () => (
    <section id="products" data-testid="product-categories-section" className="bg-slate-50">
        <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
            <SectionHeading
                eyebrow="What We Supply"
                title="Our Product Categories"
                subtitle="A diverse selection of everyday products for customers and businesses."
            />
            <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {CATEGORIES.map((category, i) => (
                    <Reveal key={category.title} delay={(i % 3) * 120}>
                        <button
                            type="button"
                            data-testid={category.testId}
                            onClick={() => scrollToHash("#contact")}
                            className="group block h-full w-full border border-slate-200 bg-white text-left transition-[box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_45px_-18px_rgba(15,23,42,0.28)]"
                        >
                            <div className="overflow-hidden">
                                <img
                                    src={category.image}
                                    alt={category.alt}
                                    loading="lazy"
                                    className="h-52 w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                                />
                            </div>
                            <div className="flex items-start justify-between gap-4 p-6">
                                <div>
                                    <h3 className="font-heading text-lg font-semibold text-navy-900">
                                        {category.title}
                                    </h3>
                                    <p className="mt-2 text-sm leading-relaxed text-slate-600">
                                        {category.description}
                                    </p>
                                </div>
                                <span className="mt-1 flex h-8 w-8 shrink-0 items-center justify-center border border-slate-200 text-slate-400 transition-colors duration-300 group-hover:border-navy-900 group-hover:bg-navy-900 group-hover:text-gold">
                                    <ArrowUpRight className="h-4 w-4" />
                                </span>
                            </div>
                        </button>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
